import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Popover,
  TextField,
  Tooltip,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  DeleteRuntimeFormData,
  fetchRuntimeFormData,
  patchFormData,
} from "../services/FormService";
import {
  pushNotification,
  setProposalCreatedId,
  setProposalData,
} from "../redux/actions";
import CONSTANTS, {
  DECISION_ENUMS,
  GET_RECORDS_LIMIT,
  INSURANCE_COMPANIES_FORM_ID,
  PROPOSAL_CONFIRMATION_CONTENT,
  PROPOSAL_CONFIRMATION_TITLE,
  PROPOSAL_STATUS,
  Table_Error_Label,
  USER_GROUPS,
} from "../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { getAllProposals } from "../services/ProposalService";
import { getRoles } from "../services/RoleService";
import Lottie from "lottie-react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Colors from "../theme/colors.json";
import DataLoader from "../animations/LoadingCube.json";
import SearchIcon from "@mui/icons-material/Search";
import { styled, lighten, darken } from "@mui/system";
import ConfirmationDialog from "../components/ConfirmationDialog";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const useStyles = makeStyles((theme) => ({
  proposalDetailsContainer: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    height: "100vh",
    "@media (min-width: 2000px)": {
      padding: "3.3%  2% 2% 2%",
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      padding: "3.3%  2% 2% 2%",
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      padding: "4.1%  2% 2% 2%",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      padding: "6.5%  2% 2% 2%",
    },
    "@media (max-width: 600px)": {
      padding: "10%  2% 2% 2%",
    },
  },
  proposalDetailsTableContainer: {
    maxHeight: "74.7vh",
    borderRadius: "0.6rem",
    "&::-webkit-scrollbar": {
      width: "0.5rem", // Initially hide the scrollbar
    },

    "&:hover": {
      "&::-webkit-scrollbar": {
        width: "0.5rem", // Adjust the width on hover
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: Colors.GRAY,
        borderRadius: 7,
      },
    },
    backgroundColor: "#FFFFFF",
  },

  proposalDetailsHeadingSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "8vh",
  },
  proposalDetailsHeadingText: {
    // display: "flex",
    // justifyContent: "flex-start",
    fontSize: "1.3rem",
    fontWeight: 600,
    color: theme.palette.secondary.main,
    visibility: "hidden",
  },
  createProposalBtnSection: {},
  createProposalBtn: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    fontWeight: "bold !important",
    textTransform: "capitalize",
    boxShadow: "unset",
    padding: "0.2rem 1.2rem",
    borderRadius: "0.2rem",
  },
  proposalIdBtn: {
    color: `${theme.palette.primary.main} !important`,
    padding: "unset !important",
    minWidth: "unset !important",
  },
  tablePagination: {},
  clientNameText: {
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 500,
    textTransform: "capitalize",
    maxWidth: "18.75rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  searchContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
  },
  tableLoader: {
    display: "flex",
    justifyContent: "center !important",
    alignItems: "center !important",
    width: "100%",
  },
  tableErrorText: {
    fontSize: "1.3rem",
    fontWeight: 300,
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
  },
  moreActionsText: {
    // color: theme.palette.primary.main,
    color: "rgba(0, 0, 0, 0.87)",
  },
  closedWonBtn: {
    color: Colors.GREEN,
    fontWeight: 500,
    // padding: "unset !important",
    minWidth: "unset !important",
    textTransform: "capitalize",
    backgroundColor: `${Colors.GREEN}25`,
    padding: "0 0.3rem",
  },
  closedLostBtn: {
    color: Colors.RED,
    fontWeight: 500,
    // padding: "unset !important",
    minWidth: "unset !important",
    textTransform: "capitalize",
    backgroundColor: `${Colors.RED}25`,
    padding: "0 0.3rem",
  },
  insuredNameStyle: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  statusText: {
    color: theme.palette.secondary.main,
  },
  searchField: {
    height: "1.865rem",
    padding: "0 0 0 0rem",
    fontSize: theme.fontSizes.LARGE,
    width: "11.316rem",
    borderRadius: "0.2rem",
  },
  tableCellData: {
    fontSize: theme.fontSizes.SMALL,
    padding: "0rem 0rem 0rem 1rem",
    lineHeight: "0.13rem !important",
  },
  searchTextField: {
    backgroundColor: Colors.WHITE_BACKGROUND,
    borderRadius: "0.3rem",
    padding: "0rem 0.7rem",
  },
  tableDataText: {
    whiteSpace: "nowrap",
  },
  fieldsMinWidth: {
    minWidth: "18vw",
  },
  fieldFonts: {
    fontSize: theme.fontSizes.SMALL,
  },
  autocompleteInputStyle: {
    fontSize: theme.fontSizes.SMALL,
    height: "0.4rem !important",
  },
  formFieldFlexColumn: {
    flex: " 0 0 49%",
    display: "flex",
    flexDirection: "column",
    // width: "30%",
    gap: "2.5%",
  },
  textField: {
    fontSize: theme.fontSizes.SMALL,
    // height: "1.875rem !important",
  },
  formFieldsFlexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
    fontSize: theme.fontSizes.SMALL,
  },
  fieldLabel: {
    color: theme.palette.secondary.main,
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 600,
  },
  btnEvent: {
    pointerEvents: "none",
    margin: "0.3rem 0 0.3rem 0",
  },
}));

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === "light"
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled("ul")({
  padding: 0,
});

const animationStyle = {
  height: "50vh",
};

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "left" | "center";
  //   format?: (value: number) => string;
}

const columns: readonly Column[] = [
  {
    id: "insuredName",
    label: "Client Name",
    minWidth: 100,
    align: "left",
  },
  {
    id: "productCategory",
    label: "Product Category",
    minWidth: 100,
    align: "left",
  },
  // { id: "productCode", label: "Product Code", minWidth: 90, align: "center" },
  {
    id: "productTitle",
    label: "Product Title",
    minWidth: 100,
    align: "left",
  },
  {
    id: "createdOn",
    label: "Created On",
    minWidth: 100,
    align: "left",
  },
  {
    id: "assignedName",
    label: "Assigned To",
    minWidth: 100,
    align: "left",
  },
  {
    id: "proposalStatus",
    label: "Status",
    minWidth: 100,
    align: "left",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "left",
  },
];

function capitalizeWords(sentence) {
  return sentence?.toLowerCase().replace(/\b\w/g, function (char) {
    return char?.toUpperCase();
  });
}

const ProposalDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { userGroup } = useSelector((state: any) => ({
    userGroup: state.userGroup,
  }));

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [tableData, setTableData] = React.useState<any>([]);
  const [searchTerm, setSearchTerm] = React.useState<any>("");
  const [backupRowData, setBackupRowData] = React.useState<any>("");
  const [isLoading, setIsloading] = React.useState(false);
  const [anchorElActions, setAnchorElActions] =
    React.useState<HTMLButtonElement | null>(null);
  const [openStatusChangeDialog, setOpenStatusChangeDialog] =
    React.useState(false);
  const [status, setStatus] = React.useState("");
  const [selectedClient, setSelectedClient] = React.useState<any>({});
  const [insuranceProviders, setInsuranceProviders] = React.useState<any>([]);

  const [leadInsurer, setLeadInsurer] = React.useState<any>({});
  const [branch, setBranch] = React.useState("");

  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const handleYes = () => {
    handleDeleteProposal(selectedClient);
  };

  const handleNo = () => {
    setConfirmDialogOpen(false);
  };

  const openActions = Boolean(anchorElActions);

  const handleClickActions = (
    event: React.MouseEvent<HTMLButtonElement>,
    client
  ) => {
    setAnchorElActions(event.currentTarget);
    setSelectedClient(client);
  };

  const handleCloseActions = () => {
    setAnchorElActions(null);
  };

  const handleClickOpenStatusChangeDialog = () => {
    setOpenStatusChangeDialog(true);
  };

  const handleCloseStatusChangeDialog = () => {
    setOpenStatusChangeDialog(false);
  };

  const handleActionMenuItemsClick = (status) => {
    handleCloseActions();
    setStatus(status);
    handleClickOpenStatusChangeDialog();
  };

  const handlePolicyManagementNavigate = () => {
    navigate(`${process.env.PUBLIC_URL}/policyManagement`);
  };

  const handleStatusClick = async (row: any) => {
    await dispatch(
      setProposalData({
        id: row?.id,
        formId: row?.formId,
        formData: row?.data,
      })
    );
    handlePolicyManagementNavigate();
  };

  const handleStatusChange = async (status) => {
    setIsloading(true);

    // Find the premium data for the selected insurance provider
    const filteredPremium =
      selectedClient?.data?.underwriterDetails?.premiumData?.find(
        (item) => item?.insuranceProvider === leadInsurer?.companyId
      );

    // Update netPremiumPaid field value based on filtered premium
    const netPremiumPaidValue = filteredPremium?.premiumBeforeTax || 0;
    const grossPremiumPaidValue = filteredPremium?.premiumAfterTax || 0;

    const body = {
      formId: selectedClient?.formId,
      id: selectedClient?.id,
      formData: {
        proposalStatus: status,
        policyManagementAndCustomerCare: {
          ...selectedClient?.data?.policyManagementAndCustomerCare,
          prePolicyPlacementData: {
            ...selectedClient?.data?.prePolicyPlacementData,
            leadInsurer: leadInsurer?.companyId,
            insurerBranch: branch,
            netPremiumPaid: netPremiumPaidValue,
            grossPremium: grossPremiumPaidValue,
            isPolicyPlacementDoneWithUs:
              status === PROPOSAL_STATUS.CLOSEDWON
                ? DECISION_ENUMS.YES
                : DECISION_ENUMS.NO,
          },
        },
      },
    };

    const response = await patchFormData(body);
    if (response?.success) {
      handleCloseActions();
      handleCloseStatusChangeDialog();
      handlegetProposalRecords();
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
      setLeadInsurer({});
      setBranch("");
      await dispatch(
        setProposalData({
          id: response?.data?.id,
          formId: response?.data?.formId,
          formData: response?.data?.formData,
        })
      );
      handlePolicyManagementNavigate();
    } else {
      setIsloading(false);
      pushNotification({
        isOpen: true,
        type: CONSTANTS.ERROR,
        message: response?.message,
      });
      setLeadInsurer({});
      setBranch("");
    }
  };

  function formatDate(inputDate) {
    if (!inputDate) {
      return "Invalid Date";
    }

    const date = new Date(inputDate);

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const handlegetProposalRecords = async () => {
    setIsloading(true);
    const response: any = await getAllProposals(true, "", page, rowsPerPage);

    if (response?.success) {
      const filteredRows = response?.data?.content?.map((item: any) => {
        return {
          data: item?.formData,
          id: item?.id,
          formId: item?.formId,
          createdOn: item?.createdOn,
          createdById: item?.createdById,
        };
      });

      setTableData(filteredRows);
      setBackupRowData(filteredRows);
      setTotalRecords(response?.data?.totalElements);
      setIsloading(false);
    } else {
      dispatch(
        pushNotification({
          isOpen: true,
          message: response.message,
          type: CONSTANTS.ERROR,
        })
      );
      setTotalRecords(0);
      setTableData([]);
      setBackupRowData([]);
      setIsloading(false);
    }
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddProposal = () => {
    navigate(`${process.env.PUBLIC_URL}/createProposal`);
  };

  const handleCreateNewProposal = () => {
    dispatch(setProposalData({}));
    navigate(`${process.env.PUBLIC_URL}/createProposal`);
  };

  const handleAddUnderWriterDetails = () => {
    navigate("/underwriterDetails");
  };

  const handleProposalClick = async (row: any) => {
    await dispatch(
      setProposalData({
        id: row?.id,
        formId: row?.formId,
        formData: row?.data,
      })
    );

    await dispatch(setProposalCreatedId(row?.createdById));

    handleAddProposal();
  };

  const handleWildcardSearch = (inputString, dataArray, setDataArray) => {
    if (!inputString || inputString.trim() === "") {
      setDataArray(backupRowData || []);
    } else {
      const escapedInput = inputString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special regex characters
      const searchResults = backupRowData.filter((data) => {
        const dataString = Object.values({ ...data.data, ...data }).join(" ");
        const regex = new RegExp(escapedInput.replace(/\*/g, ".*"), "i");
        return dataString.match(regex);
      });
      setDataArray(searchResults || []);
    }
  };

  const handleTableValueRender = (column, row, value) => {
    switch (column.id) {
      case "insuredName":
        return (
          <Button
            className={classes.proposalIdBtn}
            onClick={() => handleProposalClick(row)}
          >
            <Tooltip title={value}>
              <div className={classes.clientNameText}>{value}</div>
            </Tooltip>
          </Button>
        );
      case "createdOn":
        return formatDate(value);
      case "assignedName":
        return value ? (
          <div className={classes.tableDataText}>{value}</div>
        ) : (
          "..."
        );
      case "actions":
        return (
          <IconButton onClick={(e) => handleClickActions(e, row)}>
            <div className={classes.moreActionsText}>
              <MoreHorizIcon fontSize="small" />
            </div>
          </IconButton>
        );
      case "proposalStatus":
        return value === PROPOSAL_STATUS.CLOSEDWON ||
          value === PROPOSAL_STATUS.CLOSEDLOST ? (
          <Button
            className={`${
              value === PROPOSAL_STATUS.CLOSEDWON
                ? classes.closedWonBtn
                : classes.closedLostBtn
            } ${userGroup === USER_GROUPS.BROKER && classes.btnEvent}`}
            onClick={() => handleStatusClick(row)}
          >
            <div>{value}</div>
          </Button>
        ) : (
          <div>{value}</div>
        );
      default:
        return (
          <div className={classes.tableDataText}>{capitalizeWords(value)}</div>
        );
    }
  };

  const getInsuranceCompanies = async () => {
    const response = await fetchRuntimeFormData(
      INSURANCE_COMPANIES_FORM_ID,
      0,
      GET_RECORDS_LIMIT
    );

    const filteredCompanies = response?.data?.content?.map((item) => {
      return item?.formData;
    });

    setInsuranceProviders(filteredCompanies || []);
  };

  const handleDeleteAction = () => {
    handleCloseActions();
    setConfirmDialogOpen(true);
  };

  const handleDeleteProposal = async (selectedClient) => {
    const response = await DeleteRuntimeFormData(
      selectedClient?.formId,
      selectedClient?.id
    );
    if (response?.success) {
      setConfirmDialogOpen(false);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
      handlegetProposalRecords();
    } else {
      setConfirmDialogOpen(false);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        })
      );
    }
  };

  const handleFilterSelectedInsuranceProviders = () => {
    const selectedProviders = insuranceProviders?.filter((item) => {
      // Iterate over each object in premiumData array
      return selectedClient?.data?.underwriterDetails?.premiumData?.some(
        (premiumItem) => {
          // Check if insuranceProvider matches the companyId of the current item
          return premiumItem?.insuranceProvider === item?.companyId;
        }
      );
    });

    if (status === PROPOSAL_STATUS.CLOSEDWON) {
      return selectedProviders;
    } else {
      return insuranceProviders;
    }
  };

  React.useEffect(() => {
    getInsuranceCompanies();
  }, []);

  React.useEffect(() => {
    handleWildcardSearch(searchTerm, tableData, setTableData);
  }, [searchTerm]);

  React.useEffect(() => {
    handlegetProposalRecords();
  }, [page, rowsPerPage]);

  return (
    <div className={classes.proposalDetailsContainer}>
      <ConfirmationDialog
        open={confirmDialogOpen}
        setOpen={setConfirmDialogOpen}
        title={PROPOSAL_CONFIRMATION_TITLE}
        content={PROPOSAL_CONFIRMATION_CONTENT}
        handleYes={handleYes}
        handleNo={handleNo}
      />

      <Menu
        id="actions-menu"
        aria-labelledby="actions-menu-button"
        anchorEl={anchorElActions}
        open={openActions}
        onClose={handleCloseActions}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => handleActionMenuItemsClick(PROPOSAL_STATUS.CLOSEDWON)}
          disabled={
            selectedClient?.data?.proposalStatus ===
              PROPOSAL_STATUS.CLOSEDWON ||
            selectedClient?.data?.proposalStatus === PROPOSAL_STATUS.CLOSEDLOST
              ? true
              : false
          }
        >
          Closed Won
        </MenuItem>
        <MenuItem
          onClick={() => handleActionMenuItemsClick(PROPOSAL_STATUS.CLOSEDLOST)}
          disabled={
            selectedClient?.data?.proposalStatus ===
              PROPOSAL_STATUS.CLOSEDWON ||
            selectedClient?.data?.proposalStatus === PROPOSAL_STATUS.CLOSEDLOST
              ? true
              : false
          }
        >
          Closed Lost
        </MenuItem>
        {userGroup === USER_GROUPS.ADMIN && (
          <MenuItem onClick={handleDeleteAction}>Delete</MenuItem>
        )}
      </Menu>
      <Dialog
        open={openStatusChangeDialog}
        onClose={handleCloseStatusChangeDialog}
        aria-labelledby="alert-dialog-actions"
        aria-describedby="alert-dialog-description-actions"
      >
        <DialogTitle id="alert-dialog-title-actions">
          <div>
            Are you sure you want to change the status of{" "}
            <span className={classes.insuredNameStyle}>
              {selectedClient?.data?.insuredName}
            </span>{" "}
            to <span className={classes.statusText}>{status}</span>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className={classes.formFieldsFlexRow}>
              <div className={classes.formFieldFlexColumn}>
                <label className={classes.fieldLabel}>
                  Insurer / Lead Insurer
                </label>
                <FormControl>
                  <Autocomplete
                    fullWidth
                    disableClearable
                    id="insurance-providers-autocomplete"
                    options={handleFilterSelectedInsuranceProviders()}
                    getOptionLabel={(option: any) => option.companyId || ""}
                    groupBy={(option: any) => option.insuranceCategory}
                    value={leadInsurer}
                    onChange={(_, newValue) => setLeadInsurer(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className={classes.fieldsMinWidth}
                        size="small"
                        inputProps={{
                          ...params.inputProps,
                          className: classes.autocompleteInputStyle,
                        }}
                      />
                    )}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <GroupHeader>{params.group}</GroupHeader>
                        <GroupItems>{params.children}</GroupItems>
                      </li>
                    )}
                  />
                </FormControl>
              </div>
              <div className={classes.formFieldFlexColumn}>
                <label className={classes.fieldLabel}>Insurer Branch</label>

                <TextField
                  fullWidth
                  size="small"
                  name="insurerBranch"
                  value={branch}
                  onChange={(e) => setBranch(e.target.value)}
                  InputProps={{
                    className: classes.textField,
                  }}
                />
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCloseStatusChangeDialog}
            startIcon={<HighlightOffIcon />}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleStatusChange(status)}
            disabled={isLoading || !branch || !leadInsurer?.companyId}
            startIcon={<CheckCircleOutlineIcon />}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.proposalDetailsHeadingSection}>
        <div className={classes.proposalDetailsHeadingText}>Proposal List</div>
        <div>
          <div className={classes.searchContainer}>
            <div>
              <TextField
                className={classes.searchTextField}
                id="proposal-search"
                placeholder="Search"
                size="small"
                variant="standard"
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  classes: {
                    input: classes.searchField,
                  },
                }}
                disabled={isLoading}
              />
            </div>

            <div className={classes.createProposalBtnSection}>
              <Button
                size="small"
                variant="contained"
                className={classes.createProposalBtn}
                onClick={handleCreateNewProposal}
              >
                Create Proposal
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <TableContainer className={classes.proposalDetailsTableContainer}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns
                  ?.filter(
                    (column) =>
                      !(
                        userGroup === USER_GROUPS.BROKER &&
                        column.id === "actions"
                      )
                  )
                  ?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      sx={{
                        minWidth: column.minWidth,
                        fontWeight: 600,
                        fontSize: (theme: any) => theme.fontSizes.SMALL,
                        padding: "0.3rem 0.3rem 0.3rem 0.8rem",
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            {tableData?.length >= 1 && !isLoading && (
              <TableBody>
                {tableData?.map((row) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.proposalId}
                      sx={{ border: "unset" }}
                    >
                      {columns
                        ?.filter(
                          (column) =>
                            !(
                              userGroup === USER_GROUPS.BROKER &&
                              column.id === "actions"
                            )
                        )
                        ?.map((column) => {
                          const value = { ...row, ...row?.data }[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={classes.tableCellData}
                            >
                              {handleTableValueRender(column, row, value)}
                              {/* {column.id === "insuredName" ? (
                            <Button
                              className={classes.proposalIdBtn}
                              onClick={() => handleProposalClick(row)}
                            >
                              <div className={classes.clientNameText}>
                                {value}
                              </div>
                            </Button>
                          ) : (
                            value
                          )} */}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  );
                })}
              </TableBody>
            )}

            {isLoading && (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={7}>
                    <div className={classes.tableLoader}>
                      <Lottie animationData={DataLoader} loop={true} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {tableData?.length <= 0 && !isLoading && (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={7}>
                    <div className={classes.tableLoader}>
                      <div className={classes.tableErrorText}>
                        {Table_Error_Label}
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          className={classes.tablePagination}
          count={totalRecords}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
        />
      </div>
    </div>
  );
};

export default ProposalDetails;
